module.exports = __webpack_public_path__ + "connections-8b2284f1.webp";